// Exporta uma lista de objetos para CSV (abre no Excel) sem dependências externas.
export function exportToCSV(rows: Record<string, any>[], filename: string) {
  if (rows.length === 0) {
    alert('Não há dados para exportar.');
    return;
  }

  const headers = Object.keys(rows[0]);

  const escape = (value: any) => {
    const str = value === null || value === undefined ? '' : String(value);
    // Escapa aspas e envolve em aspas se necessário
    if (str.includes('"') || str.includes(',') || str.includes('\n') || str.includes(';')) {
      return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
  };

  // Usa ';' como separador (padrão Excel pt-BR) e BOM para acentos
  const csv = [
    headers.join(';'),
    ...rows.map(row => headers.map(h => escape(row[h])).join(';')),
  ].join('\r\n');

  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
